'use client';

import AppLogo from '@/assets/logos/app/light.svg';
import ToolsLogo from '@/assets/logos/tools/square-small.svg';
import { useLingui } from '@lingui/react';
import {
  ImportExportOutlined as ImportExportOutlinedIcon,
  MenuOpen,
} from '@mui/icons-material';
import { AppBar, Stack, Toolbar } from '@mui/material';
import { AppShellTriggerIcon, Button } from '@prismo-io/design-system';
import { Application, translate } from '@prismo-io/router';
import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
  userUrl: string;
  meHasTools: boolean;
};

const buildAppUrl = (locale: LanguageCodeT, userUrl: string) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.APP,
    path: `/`,
    // path: `/profil/:user`,
    // params: { user: userUrl },
    locale,
  });
};

const buildToolsUrl = (locale: LanguageCodeT, userUrl: string) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.TOOLS,
    path: `/`,
    addHostname: true,
    locale,
  });
};

export const SidebarHeader = (props: Props) => {
  const { userUrl, meHasTools } = props;

  const { i18n } = useLingui();
  const { locale = LanguageCode.Enum.fr } = i18n;
  const appUrl = buildAppUrl(locale as LanguageCodeT, userUrl);
  const toolsUrl = buildToolsUrl(locale as LanguageCodeT, userUrl);

  return (
    <AppBar
      position="static"
      color="transparent"
      variant="outlined"
      elevation={0}
      sx={{ border: 'none' }}
    >
      <Toolbar
        variant="dense"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '16px !important',
          paddingRight: '0 !important',
        }}
      >
        <Stack flexDirection="row" gap={2} alignItems="center">
          <Button
            variant="text"
            LinkComponent={Link}
            href={appUrl}
            sx={{ padding: 0 }}
          >
            <Image src={AppLogo} alt="Logo de PRISMO App" height={16} />
          </Button>
          {meHasTools && (
            <>
              {/* <AiOutlineSwap fontSize="small" sx={{ minWidth: 'auto' }} /> */}
              <ImportExportOutlinedIcon
                color="gray"
                fontSize="inherit"
                sx={{ transform: 'rotate(90deg)', opacity: 0.7 }}
              />
              <Button
                variant="text"
                LinkComponent={Link}
                href={toolsUrl}
                sx={{ padding: 0, minWidth: 'auto' }}
              >
                <Image src={ToolsLogo} alt="Logo de PRISMO Tools" height={16} />
              </Button>
            </>
          )}
        </Stack>
        <AppShellTriggerIcon sx={{ minWidth: 'auto' }}>
          <MenuOpen fontSize="small" color="inherit" />
        </AppShellTriggerIcon>
      </Toolbar>
    </AppBar>
  );
};
